import { AnalyticsTransformer, TrackingData } from '@panamax/app-state';

export const AdjustPaymentPageLoad: AnalyticsTransformer = (
  tracking: TrackingData,
) => ({
  capability: tracking.data.capability,
  event: tracking.data.event,
  page: {
    pageName: tracking.data.pageName,
  },
});

export const shortPaymentModalTransformer: AnalyticsTransformer = (
  tracking: TrackingData,
) => {
  const shortPayReason = tracking.data?.shortPayReason
    ? {
        payments: {
          shortPayReason: tracking.data.shortPayReason,
        },
      }
    : {};
  return {
    capability: tracking.data.capability,
    event: tracking.data.event,
    modal: {
      name: tracking.data.modalName,
    },
    ...shortPayReason,
  };
};
